import _regeneratorRuntime from "babel-runtime/regenerator";
import _asyncToGenerator from "babel-runtime/helpers/asyncToGenerator";
import _defineProperty from "babel-runtime/helpers/defineProperty";

var _mutations;

import types from "../mutation-types";
import sysConfig from "@/config/sysConfig.js";
import storage from "@/tools/storage.js";

var state = {
  editAuth: null,
  witnessAuth: null,
  checkAuth: null };

var mutations = (_mutations = {}, _defineProperty(_mutations, types.$types.UPDATE_EDIT_AUTH, function (state, res) {
  state.editAuth = res;
}), _defineProperty(_mutations, types.$types.UPDATE_CHECK_AUTH, function (state, res) {
  state.checkAuth = res;
}), _defineProperty(_mutations, types.$types.UPDATE_WITNESS_AUTH, function (state, res) {
  state.witnessAuth = res;
}), _mutations);

var actions = {
  getPermission: function getPermission(_ref, code) {
    var _this = this;

    var commit = _ref.commit;
    return _asyncToGenerator(_regeneratorRuntime.mark(function _callee() {
      var userInfo, userPhone;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit("UPDATE_WITNESS_AUTH", false);
              commit("UPDATE_CHECK_AUTH", false);
              commit("UPDATE_EDIT_AUTH", false);
              userInfo = storage.$storage.getJsonSession("USER_INFO") || {};
              userPhone = userInfo.USER_PHONE;

              if (!userPhone) {
                _context.next = 8;
                break;
              }

              console.log("开始获取权限");
              return _context.abrupt("return", sysConfig.$syscfg.K_Request("F0000046", { USER_PHONE: userPhone }).then(function (res) {
                if (res.Code == 0) {
                  var _userInfo = res.Data[0];
                  if (_userInfo.witnessPost === "true") {
                    commit("UPDATE_WITNESS_AUTH", true);
                  }
                  if (_userInfo.operatePost === "true") {
                    commit("UPDATE_CHECK_AUTH", true);
                  }

                  if (_userInfo.operatePost === "true" && _userInfo.witnessPost === "true") {
                    commit("UPDATE_EDIT_AUTH", true);
                  }
                  console.log("权限获取成功");
                } else {
                  window.vm.alert("权限获取失败,请重新登录！");
                }
              }).catch(function (err) {
                window.vm.alert("权限获取失败,请重新登录！");
              }));

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
};

export default {
  state: state,
  mutations: mutations,
  actions: actions
};


//////////////////
// WEBPACK FOOTER
// ./src/vuex/modules/permission.js
// module id = 906
// module chunks = 2